// extracted by mini-css-extract-plugin
export var mainGrid = "layout-module--mainGrid--1tL-P";
export var mainContent = "layout-module--mainContent--CW42c";
export var headerSection = "layout-module--headerSection--210V3";
export var navMenuSection = "layout-module--navMenuSection--1wD2C";
export var footerSection = "layout-module--footerSection--3OB06";